/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetStoreAction } from 'state/commonActions';

type ActionsState = {
  isLoading: boolean;
  message?: string;
  saveTriggerCounter: number;
  saveCompleted: boolean;
  pendingTabIndex: number | null;
  /** responseId of a newly created applicant; resolved to a sorted tab index in LPController's useEffect. */
  pendingResponseId: string | null;
  isManualSave: boolean;
};

const initialState: ActionsState = {
  isLoading: false,
  message: '',
  saveTriggerCounter: 0,
  saveCompleted: true,
  pendingTabIndex: null,
  pendingResponseId: null,
  isManualSave: false,
};

export const actionsSlice = createSlice({
  name: 'actions',
  initialState,
  reducers: {
    setLoadingState: (state, action: PayloadAction<Partial<ActionsState>>) => {
      const { isLoading, message } = action.payload;
      if (isLoading !== undefined) state.isLoading = isLoading;
      if (message !== undefined) state.message = message;
    },
    triggerSave: (state, action: PayloadAction<{ manual?: boolean } | undefined>) => {
      state.saveTriggerCounter += 1;
      state.saveCompleted = false;
      state.isManualSave = !!action?.payload?.manual;
    },
    setSaveCompleted: (state, action: PayloadAction<boolean>) => {
      state.saveCompleted = action.payload;
    },
    resetSaveTrigger: (state) => {
      state.saveTriggerCounter = 0;
      state.isManualSave = false;
    },
    resetSaveState: (state) => {
      state.saveTriggerCounter = 0;
      state.saveCompleted = true;
      state.pendingTabIndex = null;
      state.pendingResponseId = null;
    },
    setPendingTabIndex: (state, action: PayloadAction<number | null>) => {
      state.pendingTabIndex = action.payload;
    },
    setPendingResponseId: (state, action: PayloadAction<string | null>) => {
      state.pendingResponseId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStoreAction, () => initialState);
  },
});

export const {
  setLoadingState,
  triggerSave,
  setSaveCompleted,
  resetSaveState,
  resetSaveTrigger,
  setPendingTabIndex,
  setPendingResponseId,
} = actionsSlice.actions;

export default actionsSlice.reducer;
